<template>
  <GChart
    :type="this.typechart"
    :data="chartData"
    :options="chartOptions"
  />
</template>

<script>

  export default {
    data () {
      return {
        // Array will be automatically processed with visualization.arrayToDataTable function
        chartData: [
          ['Year', 'Sales', 'Expenses', 'Profit'],
          ['2017', 1000, 400, 200],
          ['2018', 1170, 460, 250],
          ['2019', 660, 1120, 300],
          ['2020', 1030, 540, 350]
        ],
        chartOptions: {
          chart: {
            title: 'Company Performance',
            subtitle: 'Sales, Expenses, and Profit: 2014-2017',
          }
        }
      }
    },
    props: ["typechart"]
  }
</script>